// ============= FONTE ÚNICA DE DADOS MOCKADOS =============
// Todos os dados do dashboard derivam desta fonte para garantir consistência matemática

export interface Cliente {
  id: string;
  nome: string;
  cnpj: string;
  email: string;
  telefone: string;
  reguaVinculada: string | null;
}

export interface Fatura {
  id: string;
  clienteId: string;
  valor: number;
  status: 'pending' | 'paid' | 'overdue';
  dataVencimento: string;
  dataPagamento: string | null;
  diasAtraso: number;
}

export interface Regua {
  id: string;
  nome: string;
  canalPrincipal: 'whatsapp' | 'email' | 'sms';
  steps: { sms: number; email: number; whatsapp: number };
  funil: FunnelStep[];
  isActive: boolean;
}

export interface FunnelStep {
  name: string;
  valor: number;
  fill: string;
}

export interface AgingPeriod {
  label: string;
  clientes: number;
  faturas: number;
  valor: number;
  percentual: number;
  clientesList: ClienteResumo[];
}

export interface ClienteResumo {
  id: string;
  nome: string;
  cnpj: string;
  valor: number;
  faturas: number;
}

// ============= DATA DE REFERÊNCIA =============
export const DATA_REFERENCIA = new Date().toLocaleString('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

// ============= CLIENTES BASE =============
export const CLIENTES: Cliente[] = [
  { id: '1', nome: 'XYZ Comércio Ltda', cnpj: '12.345.678/0001-90', email: 'contato@xyz.com', telefone: '11999991111', reguaVinculada: '1' },
  { id: '2', nome: 'ABC Distribuidora', cnpj: '98.765.432/0001-10', email: 'financeiro@abc.com', telefone: '11999992222', reguaVinculada: '1' },
  { id: '3', nome: 'Silva & Filhos ME', cnpj: '11.222.333/0001-44', email: 'silva@gmail.com', telefone: '11999993333', reguaVinculada: '2' },
  { id: '4', nome: 'Tech Solutions SA', cnpj: '44.555.666/0001-77', email: 'tech@solutions.com', telefone: '11999994444', reguaVinculada: '1' },
  { id: '5', nome: 'Mercado Central', cnpj: '77.888.999/0001-00', email: 'mercado@central.com', telefone: '11999995555', reguaVinculada: '2' },
  { id: '6', nome: 'Indústria Norte', cnpj: '22.333.444/0001-55', email: 'norte@industria.com', telefone: '11999996666', reguaVinculada: '1' },
  { id: '7', nome: 'Comércio Sul', cnpj: '55.666.777/0001-88', email: 'sul@comercio.com', telefone: '11999997777', reguaVinculada: '3' },
  { id: '8', nome: 'Atacado Oeste', cnpj: '88.999.000/0001-11', email: 'oeste@atacado.com', telefone: '11999998888', reguaVinculada: '1' },
  { id: '9', nome: 'Varejo Leste', cnpj: '99.000.111/0001-22', email: 'leste@varejo.com', telefone: '11999999999', reguaVinculada: '2' },
  { id: '10', nome: 'Distribuidora Express', cnpj: '33.444.555/0001-66', email: 'express@dist.com', telefone: '11988881111', reguaVinculada: null },
  { id: '11', nome: 'Mega Atacado', cnpj: '66.777.888/0001-99', email: 'mega@atacado.com', telefone: '11988882222', reguaVinculada: '1' },
  { id: '12', nome: 'Loja Premium', cnpj: '00.111.222/0001-33', email: 'premium@loja.com', telefone: '11988883333', reguaVinculada: '2' },
  { id: '13', nome: 'Supermercado Top', cnpj: '44.666.888/0001-11', email: 'top@super.com', telefone: '11988884444', reguaVinculada: '1' },
  { id: '14', nome: 'Farmácia Popular', cnpj: '77.999.111/0001-22', email: 'popular@farm.com', telefone: '11988885555', reguaVinculada: '3' },
  { id: '15', nome: 'Padaria Central', cnpj: '11.333.555/0001-77', email: 'central@padaria.com', telefone: '11988886666', reguaVinculada: null },
  { id: '16', nome: 'Restaurante Sabor', cnpj: '22.444.666/0001-88', email: 'sabor@rest.com', telefone: '11988887777', reguaVinculada: '1' },
  { id: '17', nome: 'Hotel Estrela', cnpj: '33.555.777/0001-99', email: 'estrela@hotel.com', telefone: '11988888888', reguaVinculada: '2' },
  { id: '18', nome: 'Academia Fit', cnpj: '44.666.888/0001-00', email: 'fit@academia.com', telefone: '11988889999', reguaVinculada: '1' },
  { id: '19', nome: 'Clínica Saúde', cnpj: '55.777.999/0001-11', email: 'saude@clinica.com', telefone: '11977771111', reguaVinculada: '3' },
  { id: '20', nome: 'Escola Aprender', cnpj: '66.888.000/0001-22', email: 'aprender@escola.com', telefone: '11977772222', reguaVinculada: '1' },
  { id: '21', nome: 'Construtora Alfa', cnpj: '77.999.111/0001-33', email: 'alfa@const.com', telefone: '11977773333', reguaVinculada: null },
  { id: '22', nome: 'Imobiliária Beta', cnpj: '88.000.222/0001-44', email: 'beta@imob.com', telefone: '11977774444', reguaVinculada: '2' },
  { id: '23', nome: 'Transportadora Gama', cnpj: '99.111.333/0001-55', email: 'gama@transp.com', telefone: '11977775555', reguaVinculada: '1' },
  { id: '24', nome: 'Oficina Delta', cnpj: '00.222.444/0001-66', email: 'delta@oficina.com', telefone: '11977776666', reguaVinculada: '3' },
  { id: '25', nome: 'Pet Shop Amigo', cnpj: '11.333.555/0001-77', email: 'amigo@petshop.com', telefone: '11977777777', reguaVinculada: '1' },
  { id: '26', nome: 'Eletrônicos Plus', cnpj: '22.444.666/0001-88', email: 'plus@eletron.com', telefone: '11977778888', reguaVinculada: '2' },
  { id: '27', nome: 'Móveis Design', cnpj: '33.555.777/0001-99', email: 'design@moveis.com', telefone: '11977779999', reguaVinculada: null },
  { id: '28', nome: 'Papelaria Criativa', cnpj: '44.666.888/0001-00', email: 'criativa@papel.com', telefone: '11966661111', reguaVinculada: '1' },
  { id: '29', nome: 'Gráfica Rápida', cnpj: '55.777.999/0001-11', email: 'rapida@grafica.com', telefone: '11966662222', reguaVinculada: '2' },
  { id: '30', nome: 'Consultoria Omega', cnpj: '66.888.000/0001-22', email: 'omega@consult.com', telefone: '11966663333', reguaVinculada: '3' },
];

// ============= FATURAS BASE =============
// Gerando faturas com base nos clientes para consistência
const hoje = new Date();

function gerarDataVencimento(diasAtras: number): string {
  const data = new Date(hoje);
  data.setDate(data.getDate() - diasAtras);
  return data.toISOString().split('T')[0];
}

function gerarDataFutura(diasAfrente: number): string {
  const data = new Date(hoje);
  data.setDate(data.getDate() + diasAfrente);
  return data.toISOString().split('T')[0];
}

function gerarDataHoje(): string {
  return hoje.toISOString().split('T')[0];
}

export const FATURAS: Fatura[] = [
  // Faturas para vencer HOJE
  { id: 'f0a', clienteId: '1', valor: 28500, status: 'pending', dataVencimento: gerarDataHoje(), dataPagamento: null, diasAtraso: 0 },
  { id: 'f0b', clienteId: '2', valor: 35200, status: 'pending', dataVencimento: gerarDataHoje(), dataPagamento: null, diasAtraso: 0 },
  { id: 'f0c', clienteId: '6', valor: 42800, status: 'pending', dataVencimento: gerarDataHoje(), dataPagamento: null, diasAtraso: 0 },
  
  // Faturas em aberto (próximos dias)
  { id: 'f1', clienteId: '1', valor: 5400, status: 'pending', dataVencimento: gerarDataFutura(2), dataPagamento: null, diasAtraso: 0 },
  { id: 'f2', clienteId: '2', valor: 3200, status: 'pending', dataVencimento: gerarDataFutura(5), dataPagamento: null, diasAtraso: 0 },
  { id: 'f3', clienteId: '3', valor: 8900, status: 'pending', dataVencimento: gerarDataFutura(3), dataPagamento: null, diasAtraso: 0 },
  { id: 'f4', clienteId: '4', valor: 2100, status: 'pending', dataVencimento: gerarDataFutura(7), dataPagamento: null, diasAtraso: 0 },
  { id: 'f5', clienteId: '5', valor: 4500, status: 'pending', dataVencimento: gerarDataFutura(1), dataPagamento: null, diasAtraso: 0 },
  { id: 'f6', clienteId: '6', valor: 6200, status: 'pending', dataVencimento: gerarDataFutura(10), dataPagamento: null, diasAtraso: 0 },
  { id: 'f7', clienteId: '7', valor: 3800, status: 'pending', dataVencimento: gerarDataFutura(12), dataPagamento: null, diasAtraso: 0 },
  { id: 'f8', clienteId: '8', valor: 7500, status: 'pending', dataVencimento: gerarDataFutura(8), dataPagamento: null, diasAtraso: 0 },
  { id: 'f9', clienteId: '9', valor: 2800, status: 'pending', dataVencimento: gerarDataFutura(15), dataPagamento: null, diasAtraso: 0 },
  { id: 'f10', clienteId: '10', valor: 4100, status: 'pending', dataVencimento: gerarDataFutura(20), dataPagamento: null, diasAtraso: 0 },
  { id: 'f11', clienteId: '11', valor: 5600, status: 'pending', dataVencimento: gerarDataFutura(25), dataPagamento: null, diasAtraso: 0 },
  { id: 'f12', clienteId: '12', valor: 3400, status: 'pending', dataVencimento: gerarDataFutura(35), dataPagamento: null, diasAtraso: 0 },
  { id: 'f13', clienteId: '13', valor: 8200, status: 'pending', dataVencimento: gerarDataFutura(45), dataPagamento: null, diasAtraso: 0 },
  { id: 'f14', clienteId: '14', valor: 2900, status: 'pending', dataVencimento: gerarDataFutura(55), dataPagamento: null, diasAtraso: 0 },
  { id: 'f15', clienteId: '15', valor: 6700, status: 'pending', dataVencimento: gerarDataFutura(65), dataPagamento: null, diasAtraso: 0 },
  { id: 'f16', clienteId: '16', valor: 4300, status: 'pending', dataVencimento: gerarDataFutura(4), dataPagamento: null, diasAtraso: 0 },
  { id: 'f17', clienteId: '17', valor: 5100, status: 'pending', dataVencimento: gerarDataFutura(6), dataPagamento: null, diasAtraso: 0 },
  { id: 'f18', clienteId: '18', valor: 3600, status: 'pending', dataVencimento: gerarDataFutura(9), dataPagamento: null, diasAtraso: 0 },
  
  // Faturas vencidas (em atraso)
  { id: 'f19', clienteId: '1', valor: 15400, status: 'overdue', dataVencimento: gerarDataVencimento(32), dataPagamento: null, diasAtraso: 32 },
  { id: 'f20', clienteId: '2', valor: 12800, status: 'overdue', dataVencimento: gerarDataVencimento(28), dataPagamento: null, diasAtraso: 28 },
  { id: 'f21', clienteId: '3', valor: 8900, status: 'overdue', dataVencimento: gerarDataVencimento(21), dataPagamento: null, diasAtraso: 21 },
  { id: 'f22', clienteId: '4', valor: 6500, status: 'overdue', dataVencimento: gerarDataVencimento(15), dataPagamento: null, diasAtraso: 15 },
  { id: 'f23', clienteId: '5', valor: 4200, status: 'overdue', dataVencimento: gerarDataVencimento(12), dataPagamento: null, diasAtraso: 12 },
  { id: 'f24', clienteId: '19', valor: 3100, status: 'overdue', dataVencimento: gerarDataVencimento(5), dataPagamento: null, diasAtraso: 5 },
  { id: 'f25', clienteId: '20', valor: 2800, status: 'overdue', dataVencimento: gerarDataVencimento(3), dataPagamento: null, diasAtraso: 3 },
  { id: 'f26', clienteId: '21', valor: 4500, status: 'overdue', dataVencimento: gerarDataVencimento(8), dataPagamento: null, diasAtraso: 8 },
  { id: 'f27', clienteId: '22', valor: 3700, status: 'overdue', dataVencimento: gerarDataVencimento(10), dataPagamento: null, diasAtraso: 10 },
  { id: 'f28', clienteId: '23', valor: 5200, status: 'overdue', dataVencimento: gerarDataVencimento(18), dataPagamento: null, diasAtraso: 18 },
  { id: 'f29', clienteId: '24', valor: 6800, status: 'overdue', dataVencimento: gerarDataVencimento(25), dataPagamento: null, diasAtraso: 25 },
  { id: 'f30', clienteId: '25', valor: 2400, status: 'overdue', dataVencimento: gerarDataVencimento(45), dataPagamento: null, diasAtraso: 45 },
  { id: 'f31', clienteId: '26', valor: 3900, status: 'overdue', dataVencimento: gerarDataVencimento(60), dataPagamento: null, diasAtraso: 60 },
  { id: 'f32', clienteId: '27', valor: 5500, status: 'overdue', dataVencimento: gerarDataVencimento(95), dataPagamento: null, diasAtraso: 95 },
  { id: 'f33', clienteId: '28', valor: 2100, status: 'overdue', dataVencimento: gerarDataVencimento(4), dataPagamento: null, diasAtraso: 4 },
  
  // Faturas pagas (para cálculo de recuperação)
  { id: 'f34', clienteId: '29', valor: 8500, status: 'paid', dataVencimento: gerarDataVencimento(15), dataPagamento: gerarDataVencimento(10), diasAtraso: 0 },
  { id: 'f35', clienteId: '30', valor: 12000, status: 'paid', dataVencimento: gerarDataVencimento(20), dataPagamento: gerarDataVencimento(18), diasAtraso: 0 },
  { id: 'f36', clienteId: '11', valor: 6500, status: 'paid', dataVencimento: gerarDataVencimento(25), dataPagamento: gerarDataVencimento(23), diasAtraso: 0 },
  { id: 'f37', clienteId: '12', valor: 9200, status: 'paid', dataVencimento: gerarDataVencimento(30), dataPagamento: gerarDataVencimento(28), diasAtraso: 0 },
  { id: 'f38', clienteId: '13', valor: 4800, status: 'paid', dataVencimento: gerarDataVencimento(12), dataPagamento: gerarDataVencimento(11), diasAtraso: 0 },
  { id: 'f39', clienteId: '14', valor: 7300, status: 'paid', dataVencimento: gerarDataVencimento(18), dataPagamento: gerarDataVencimento(15), diasAtraso: 0 },
  { id: 'f40', clienteId: '15', valor: 5100, status: 'paid', dataVencimento: gerarDataVencimento(22), dataPagamento: gerarDataVencimento(20), diasAtraso: 0 },
  { id: 'f41', clienteId: '16', valor: 11200, status: 'paid', dataVencimento: gerarDataVencimento(28), dataPagamento: gerarDataVencimento(25), diasAtraso: 0 },
  { id: 'f42', clienteId: '17', valor: 8900, status: 'paid', dataVencimento: gerarDataVencimento(35), dataPagamento: gerarDataVencimento(32), diasAtraso: 0 },
  { id: 'f43', clienteId: '18', valor: 6700, status: 'paid', dataVencimento: gerarDataVencimento(40), dataPagamento: gerarDataVencimento(38), diasAtraso: 0 },
  { id: 'f44', clienteId: '6', valor: 15500, status: 'paid', dataVencimento: gerarDataVencimento(45), dataPagamento: gerarDataVencimento(42), diasAtraso: 0 },
  { id: 'f45', clienteId: '7', valor: 9800, status: 'paid', dataVencimento: gerarDataVencimento(50), dataPagamento: gerarDataVencimento(48), diasAtraso: 0 },
  { id: 'f46', clienteId: '8', valor: 7200, status: 'paid', dataVencimento: gerarDataVencimento(55), dataPagamento: gerarDataVencimento(52), diasAtraso: 0 },
  { id: 'f47', clienteId: '9', valor: 4600, status: 'paid', dataVencimento: gerarDataVencimento(60), dataPagamento: gerarDataVencimento(58), diasAtraso: 0 },
  { id: 'f48', clienteId: '10', valor: 8100, status: 'paid', dataVencimento: gerarDataVencimento(65), dataPagamento: gerarDataVencimento(62), diasAtraso: 0 },
  { id: 'f49', clienteId: '23', valor: 12400, status: 'paid', dataVencimento: gerarDataVencimento(70), dataPagamento: gerarDataVencimento(68), diasAtraso: 0 },
  { id: 'f50', clienteId: '24', valor: 5900, status: 'paid', dataVencimento: gerarDataVencimento(75), dataPagamento: gerarDataVencimento(72), diasAtraso: 0 },
];

// ============= RÉGUAS BASE =============
export const REGUAS: Regua[] = [
  {
    id: '1',
    nome: 'Cobrança Inicial (0-5 dias)',
    canalPrincipal: 'whatsapp',
    steps: { sms: 8, email: 4, whatsapp: 5 },
    funil: [
      { name: 'Enviados', valor: 5800, fill: 'hsl(var(--muted-foreground))' },
      { name: 'Entregues', valor: 5680, fill: 'hsl(220, 70%, 55%)' },
      { name: 'Lidos', valor: 4200, fill: 'hsl(var(--basic-500))' },
      { name: 'Clicaram', valor: 3150, fill: 'hsl(270, 70%, 55%)' },
      { name: 'Pagaram', valor: 2520, fill: 'hsl(var(--accent-500))' },
    ],
    isActive: true,
  },
  {
    id: '2',
    nome: 'Cobrança Intensiva (6-14 dias)',
    canalPrincipal: 'email',
    steps: { sms: 10, email: 6, whatsapp: 3 },
    funil: [
      { name: 'Enviados', valor: 4200, fill: 'hsl(var(--muted-foreground))' },
      { name: 'Entregues', valor: 4100, fill: 'hsl(220, 70%, 55%)' },
      { name: 'Lidos', valor: 2870, fill: 'hsl(var(--basic-500))' },
      { name: 'Clicaram', valor: 2050, fill: 'hsl(270, 70%, 55%)' },
      { name: 'Pagaram', valor: 1640, fill: 'hsl(var(--accent-500))' },
    ],
    isActive: true,
  },
  {
    id: '3',
    nome: 'Cobrança Judicial (15+ dias)',
    canalPrincipal: 'sms',
    steps: { sms: 4, email: 2, whatsapp: 1 },
    funil: [
      { name: 'Enviados', valor: 5000, fill: 'hsl(var(--muted-foreground))' },
      { name: 'Entregues', valor: 5020, fill: 'hsl(220, 70%, 55%)' },
      { name: 'Lidos', valor: 4130, fill: 'hsl(var(--basic-500))' },
      { name: 'Clicaram', valor: 3300, fill: 'hsl(270, 70%, 55%)' },
      { name: 'Pagaram', valor: 2040, fill: 'hsl(var(--accent-500))' },
    ],
    isActive: true,
  },
];

// ============= FUNÇÕES DERIVADAS =============

// Agrupa clientes por período de aging
function agruparClientesPorPeriodo(
  faturas: Fatura[],
  periodos: { min: number; max: number; label: string }[],
  tipo: 'open' | 'overdue'
): AgingPeriod[] {
  return periodos.map((periodo) => {
    const faturasFiltradas = faturas.filter((f) => {
      if (tipo === 'open') {
        // Para aberto, calculamos dias até vencimento
        const diasAteVencimento = Math.ceil(
          (new Date(f.dataVencimento).getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24)
        );
        return f.status === 'pending' && diasAteVencimento >= periodo.min && diasAteVencimento <= periodo.max;
      } else {
        // Para vencido, usamos dias de atraso
        return f.status === 'overdue' && f.diasAtraso >= periodo.min && f.diasAtraso <= periodo.max;
      }
    });

    // Agrupa por cliente
    const clientesMap = new Map<string, { valor: number; faturas: number }>();
    faturasFiltradas.forEach((f) => {
      const existing = clientesMap.get(f.clienteId) || { valor: 0, faturas: 0 };
      clientesMap.set(f.clienteId, {
        valor: existing.valor + f.valor,
        faturas: existing.faturas + 1,
      });
    });

    const clientesList: ClienteResumo[] = Array.from(clientesMap.entries()).map(([clienteId, data]) => {
      const cliente = CLIENTES.find((c) => c.id === clienteId)!;
      return {
        id: clienteId,
        nome: cliente.nome,
        cnpj: cliente.cnpj,
        valor: data.valor,
        faturas: data.faturas,
      };
    });

    const valor = faturasFiltradas.reduce((sum, f) => sum + f.valor, 0);

    return {
      label: periodo.label,
      clientes: clientesMap.size,
      faturas: faturasFiltradas.length,
      valor,
      percentual: 0, // Será calculado depois
      clientesList,
    };
  });
}

// Calcula percentuais
function calcularPercentuais(periodos: AgingPeriod[]): AgingPeriod[] {
  const total = periodos.reduce((sum, p) => sum + p.valor, 0);
  return periodos.map((p) => ({
    ...p,
    percentual: total > 0 ? Math.round((p.valor / total) * 100) : 0,
  }));
}

// Aging em Aberto (próximos dias)
export function getAgingOpen(): AgingPeriod[] {
  const periodos = [
    { min: 0, max: 7, label: 'Próximos 7 dias' },
    { min: 8, max: 15, label: 'De 8 a 15 dias' },
    { min: 16, max: 30, label: 'De 16 a 30 dias' },
    { min: 31, max: 60, label: 'De 31 a 60 dias' },
    { min: 61, max: 999, label: 'Acima de 60 dias' },
  ];
  const dados = agruparClientesPorPeriodo(FATURAS, periodos, 'open');
  return calcularPercentuais(dados);
}

// Aging Vencido (dias de atraso)
export function getAgingOverdue(): AgingPeriod[] {
  const periodos = [
    { min: 1, max: 7, label: 'Últimos 7 dias' },
    { min: 8, max: 15, label: 'De 8 a 15 dias' },
    { min: 16, max: 30, label: 'De 16 a 30 dias' },
    { min: 31, max: 60, label: 'De 31 a 60 dias' },
    { min: 61, max: 999, label: 'Acima de 90 dias' },
  ];
  const dados = agruparClientesPorPeriodo(FATURAS, periodos, 'overdue');
  return calcularPercentuais(dados);
}

// KPIs da aba Resumo
export function getKpisResumo() {
  const hojeStr = hoje.toISOString().split('T')[0];
  
  const faturasHoje = FATURAS.filter((f) => {
    return f.status === 'pending' && f.dataVencimento === hojeStr;
  });

  const faturasVencidas2d = FATURAS.filter(
    (f) => f.status === 'overdue' && f.diasAtraso >= 2
  );

  const faturasAbertas = FATURAS.filter((f) => f.status === 'pending');

  // clientesHoje não é usado - valor fixo de 43 para demonstração
  const clientesVencidos = new Set(faturasVencidas2d.map((f) => f.clienteId)).size;

  return {
    receberHoje: faturasHoje.reduce((sum, f) => sum + f.valor, 0),
    receberHojeClientes: 43, // Valor fixo para demonstração
    vencido2d: faturasVencidas2d.reduce((sum, f) => sum + f.valor, 0),
    vencido2dClientes: clientesVencidos,
    saldoGeral: faturasAbertas.reduce((sum, f) => sum + f.valor, 0),
    saldoGeralFaturas: faturasAbertas.length,
  };
}

// KPIs da aba Recuperação
export function getKpisRecuperacao() {
  const faturasPagas = FATURAS.filter((f) => f.status === 'paid');
  const faturasVencidas = FATURAS.filter((f) => f.status === 'overdue');
  
  const totalRecuperado = faturasPagas.reduce((sum, f) => sum + f.valor, 0);
  const totalVencido = faturasVencidas.reduce((sum, f) => sum + f.valor, 0);
  const taxaRecuperacao = totalVencido + totalRecuperado > 0 
    ? (totalRecuperado / (totalVencido + totalRecuperado)) * 100 
    : 0;

  return {
    totalRecuperado,
    taxaRecuperacao: Math.round(taxaRecuperacao * 10) / 10,
    melhorCanal: 'WhatsApp',
    valorMedioRecuperado: faturasPagas.length > 0 
      ? Math.round(totalRecuperado / faturasPagas.length) 
      : 0,
  };
}

// KPIs da aba Devedores
export function getKpisDevedores() {
  const faturasVencidas = FATURAS.filter((f) => f.status === 'overdue');
  const clientesDevedores = new Set(faturasVencidas.map((f) => f.clienteId));
  const totalInadimplente = faturasVencidas.reduce((sum, f) => sum + f.valor, 0);
  const diasMedio = faturasVencidas.length > 0
    ? Math.round(faturasVencidas.reduce((sum, f) => sum + f.diasAtraso, 0) / faturasVencidas.length)
    : 0;

  return {
    totalInadimplente,
    clientesAtraso: clientesDevedores.size,
    ticketMedio: clientesDevedores.size > 0 
      ? Math.round(totalInadimplente / clientesDevedores.size) 
      : 0,
    diasMedioAtraso: diasMedio,
  };
}

// Top Devedores
export function getTopDevedores() {
  const faturasVencidas = FATURAS.filter((f) => f.status === 'overdue');
  
  // Agrupa por cliente
  const devedoresMap = new Map<string, { valor: number; diasMax: number }>();
  faturasVencidas.forEach((f) => {
    const existing = devedoresMap.get(f.clienteId) || { valor: 0, diasMax: 0 };
    devedoresMap.set(f.clienteId, {
      valor: existing.valor + f.valor,
      diasMax: Math.max(existing.diasMax, f.diasAtraso),
    });
  });

  return Array.from(devedoresMap.entries())
    .map(([clienteId, data]) => {
      const cliente = CLIENTES.find((c) => c.id === clienteId)!;
      return {
        id: clienteId,
        name: cliente.nome,
        amount: data.valor,
        daysOverdue: data.diasMax,
      };
    })
    .sort((a, b) => b.amount - a.amount)
    .slice(0, 5);
}

// Steps Stats (total por canal)
export function getStepsStats() {
  return REGUAS.reduce(
    (acc, regua) => ({
      sms: acc.sms + regua.steps.sms,
      email: acc.email + regua.steps.email,
      whatsapp: acc.whatsapp + regua.steps.whatsapp,
    }),
    { sms: 0, email: 0, whatsapp: 0 }
  );
}

// Dados do gráfico de fluxo de caixa
export interface ChartDataPoint {
  name: string;
  recebido: number;
  vencido: number;
  aReceber: number;
  projecao: number;
}

// Helpers para formatação de datas
const diasSemana = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
const mesesAbrev = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

function formatarDataDia(data: Date): string {
  const dia = String(data.getDate()).padStart(2, '0');
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const diaSemana = diasSemana[data.getDay()];
  return `${diaSemana.charAt(0).toUpperCase() + diaSemana.slice(1)} ${dia}/${mes}`;
}

function formatarSemana(inicioData: Date, fimData: Date, numSemana: number): string {
  const inicioStr = `${String(inicioData.getDate()).padStart(2, '0')}/${String(inicioData.getMonth() + 1).padStart(2, '0')}`;
  const fimStr = `${String(fimData.getDate()).padStart(2, '0')}/${String(fimData.getMonth() + 1).padStart(2, '0')}`;
  return `Sem ${numSemana} (${inicioStr} a ${fimStr})`;
}

function formatarMes(data: Date): string {
  const mes = mesesAbrev[data.getMonth()];
  const ano = data.getFullYear();
  return `${mes.charAt(0).toUpperCase() + mes.slice(1)}/${ano}`;
}

export function getChartData(periodo: 'day' | 'week' | 'month'): ChartDataPoint[] {
  // Taxa de recuperação histórica para projeção: 87%
  const baseDate = new Date(hoje);

  if (periodo === 'day') {
    // Gerar 7 dias: 3 passados + hoje + 3 futuros
    const dados: ChartDataPoint[] = [];
    const valoresRecebido = [2200, 3100, 2800, 4400, 0, 0, 0]; // passado tem recebido
    const valoresVencido = [800, 400, 600, 200, 100, 50, 0];
    const valoresAReceber = [0, 0, 0, 0, 2500, 1200, 500]; // só futuro tem a receber
    
    for (let i = 0; i < 7; i++) {
      const data = new Date(baseDate);
      data.setDate(data.getDate() + (i - 3)); // -3 a +3 dias
      const isFuturo = i > 3; // índices 4, 5, 6 são futuros
      dados.push({
        name: formatarDataDia(data),
        recebido: valoresRecebido[i],
        vencido: valoresVencido[i],
        aReceber: isFuturo ? valoresAReceber[i] : 0,
        projecao: isFuturo ? Math.round(valoresAReceber[i] * 0.87) : 0,
      });
    }
    return dados;
  }

  if (periodo === 'week') {
    // Gerar 4 semanas: 2 passadas + semana atual + 1 futura
    const dados: ChartDataPoint[] = [];
    const valoresRecebido = [14000, 19500, 8200, 0]; // passado tem recebido, atual parcial
    const valoresVencido = [8000, 6200, 2100, 0];
    const valoresAReceber = [0, 0, 12000, 35000]; // só atual (parcial) e futuro tem a receber
    
    // Encontrar início da semana atual (segunda-feira)
    const inicioSemana = new Date(baseDate);
    const diaSemana = inicioSemana.getDay();
    const diffParaSegunda = diaSemana === 0 ? -6 : 1 - diaSemana;
    inicioSemana.setDate(inicioSemana.getDate() + diffParaSegunda);
    
    for (let i = 0; i < 4; i++) {
      const inicio = new Date(inicioSemana);
      inicio.setDate(inicio.getDate() + ((i - 2) * 7)); // -2 a +1 semanas
      const fim = new Date(inicio);
      fim.setDate(fim.getDate() + 6);
      
      const isFuturo = i >= 2; // semana atual (índice 2) e futura (índice 3)
      dados.push({
        name: formatarSemana(inicio, fim, i + 1),
        recebido: valoresRecebido[i],
        vencido: valoresVencido[i],
        aReceber: isFuturo ? valoresAReceber[i] : 0,
        projecao: isFuturo ? Math.round(valoresAReceber[i] * 0.87) : 0,
      });
    }
    return dados;
  }

  // month - 4 meses passados + mês atual + 1 futuro
  const dados: ChartDataPoint[] = [];
  const valoresRecebido = [45000, 52000, 49000, 61000, 28000, 0]; // passado tem recebido, atual parcial
  const valoresVencido = [22000, 18000, 15000, 12000, 4000, 0];
  const valoresAReceber = [0, 0, 0, 0, 47000, 85000]; // só atual (parcial) e futuro tem a receber
  
  for (let i = 0; i < 6; i++) {
    const data = new Date(baseDate);
    data.setMonth(data.getMonth() + (i - 4)); // -4 a +1 meses
    const isFuturo = i >= 4; // mês atual (índice 4) e futuro (índice 5)
    dados.push({
      name: formatarMes(data),
      recebido: valoresRecebido[i],
      vencido: valoresVencido[i],
      aReceber: isFuturo ? valoresAReceber[i] : 0,
      projecao: isFuturo ? Math.round(valoresAReceber[i] * 0.87) : 0,
    });
  }
  return dados;
}

// Funil por régua
export function getFunnelByRegua(reguaId: string | 'all'): FunnelStep[] {
  if (reguaId === 'all') {
    // Soma todos os funis
    const totais = REGUAS.reduce(
      (acc, regua) => {
        regua.funil.forEach((step, index) => {
          if (!acc[index]) {
            acc[index] = { name: step.name, valor: 0, fill: step.fill };
          }
          acc[index].valor += step.valor;
        });
        return acc;
      },
      [] as FunnelStep[]
    );
    return totais;
  }

  const regua = REGUAS.find((r) => r.id === reguaId);
  return regua?.funil || [];
}

// Clientes por período (para modal de detalhes)
export function getClientesByPeriodo(tipo: 'open' | 'overdue', periodoLabel: string): ClienteResumo[] {
  const aging = tipo === 'open' ? getAgingOpen() : getAgingOverdue();
  const periodo = aging.find((p) => p.label === periodoLabel);
  return periodo?.clientesList || [];
}

// Dados para Aging Donut Chart
export function getAgingDonutData() {
  const agingOpen = getAgingOpen();
  return agingOpen.map((periodo, index) => {
    const colors = [
      'hsl(var(--basic-500))',
      'hsl(220, 70%, 55%)',
      'hsl(38, 92%, 50%)',
      'hsl(var(--careful-400))',
      'hsl(var(--careful-600))',
    ];
    return {
      name: periodo.label.replace('Próximos ', '').replace('De ', '').replace('Acima de ', '+'),
      value: periodo.valor,
      fill: colors[index] || 'hsl(var(--muted-foreground))',
    };
  });
}

// Performance das réguas
export function getReguasPerformance() {
  return REGUAS.map((regua) => {
    const funil = regua.funil;
    const enviados = funil[0]?.valor || 0;
    const pagaram = funil[funil.length - 1]?.valor || 0;
    const taxaPagamento = enviados > 0 ? Math.round((pagaram / enviados) * 100) : 0;
    const taxaInadimplencia = 100 - taxaPagamento;
    
    return {
      ruleId: regua.id,
      ruleName: regua.nome,
      invoicesSent: enviados,
      invoicesPaid: pagaram,
      paymentRate: taxaPagamento,
      overdueInvoices: enviados - pagaram,
      defaultRate: taxaInadimplencia,
      avgPaymentDays: regua.id === '1' ? 3 : regua.id === '2' ? 10 : 22,
      topChannel: regua.canalPrincipal,
      engagementRate: regua.id === '1' ? 92 : regua.id === '2' ? 75 : 58,
      isActive: regua.isActive,
    };
  });
}
